module.exports = __webpack_public_path__ + "static/media/001-Lionshead.a6c17b5d.png";